/**
 * Created with IntelliJ IDEA.
 * User: raml
 * Date: 3/19/13
 * Time: 3:57 AM
 * Connection Module used main code - used to start the module functions
 * used from the application
 */
define(["app", "connection-controllers/ConnectionPanelController", "connection-controllers/ConnectionRouteController", "Chronos.PostMessageCourier"],
    function (LE, ConnectionPanelController, ConnectionRouteController, LPCourier) {
    "use strict";

    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        LEConnection.addInitializer(function () {
            LEConnection.courier = new LPCourier();
            LEConnection.routeController = new ConnectionRouteController();
            LEConnection.connectionPanelController = new ConnectionPanelController();
        });
        LEConnection.getMainView = function () {
           return LEConnection.connectionPanelController.getMainView();
        };
        LEConnection.getLeaveConfirmationText = function () {
            LEConnection.connectionPanelController.onLeave();
        };
        LEConnection.getRouteController = function () {
            return LEConnection.routeController;
        };
    });

    return LE.module("LEConnection");
});
